ddocument.addEventListener("submit", (event) => {
  const form = event.target.closest("[data-peek-breed-form]");
  if (!form) return;

  event.preventDefault();
  const select = form.querySelector("[data-peek-breed-select]");
  if (select?.value) window.location.assign(select.value);
});

document.addEventListener("click", (event) => {
  document.querySelectorAll(".peek-nav__details[open]").forEach((details) => {
    if (!details.contains(event.target)) details.removeAttribute("open");
  });
});
